import axios from 'lib/axios';

const physicalPayment = async (values) => {
  const { body, orderId } = values;
  const { data } = await axios.post(`/v2/payment/${orderId}/done`, body);
  return data;
};

const getCustomerPayments = async (id) => {
  const { data } = await axios.get(`/v2/payment/customer/${id}`);
  return data;
};

const getOrderById = async (id) => {
  const { data } = await axios.get(`/v2/payment/order/${id}`);
  return data;
};

const getPendingInvoices = async ({ page = 1, limit = 20, search = '' } = {}) => {
  const params = new URLSearchParams({ page, limit });
  if (search) params.set('search', search);
  const { data } = await axios.get(`/v2/payment/pending?${params.toString()}`);
  return data;
};

const getCashBox = async () => {
  const { data } = await axios.get(`/v2/payment/cashbox`);
  return data;
};

const adjustCashBox = async ({ branch, type, denominations, description }) => {
  const { data } = await axios.post(`/v2/payment/cashbox/adjust`, {
    branch: 'general',
    type,
    denominations,
    description,
  });
  return data;
};

const getReceiptByNumber = async (receiptNumber) => {
  const { data } = await axios.get(`/admin/receipts/${receiptNumber}`);
  return data;
};

const updateReceiptByNumber = async ({ receiptNumber, body }) => {
  const { data } = await axios.patch(`/admin/receipts/${receiptNumber}`, body);
  return data;
};

const cancelReceiptByNumber = async ({ receiptNumber, reason }) => {
  const { data } = await axios.post(`/admin/receipts/${receiptNumber}/cancel`, { reason });
  return data;
};

export {
  physicalPayment,
  getCustomerPayments,
  getOrderById,
  getPendingInvoices,
  getCashBox,
  adjustCashBox,
  getReceiptByNumber,
  updateReceiptByNumber,
  cancelReceiptByNumber,
};
